import React from 'react';
import config from '../../config';
import { useCitiesStore } from '../../hooks/useCitiesStore';
import { useCityBuilder } from '../../hooks/useCityBuilder';
import EmptyState from '../EmptyState';
import Spinner from '../Spinner';
import CityPreview from './CityPreview';
import { useUserAssetsQuery } from '../../hooks/useUserAssetsStore';
import { useWallet } from '@txnlab/use-wallet';

const CityBuilderCitySelector = ({ myCities }) => {
  const { selectCity } = useCityBuilder();
  const { loading } = useCitiesStore();
  const { activeAddress } = useWallet();
  const userAssetsQuery = useUserAssetsQuery({ address: activeAddress });

  if (loading || userAssetsQuery.isLoading) {
    return (
      <div className='h-[400px] flex items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (!myCities.length) {
    return (
      <div className='flex justify-center mt-20'>
        <EmptyState message="We didn't find any Shitty Cities in your wallet." action={{ href: config.cityBuyNow, text: 'Buy a Shitty City' }} />
      </div>
    );
  }

  return (
    <>
      <p className='text-gray-300 text-xl max-w-xl'>All your Shitty Cities are listed below. Please select the city that you would like to update.</p>

      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
        {myCities.map((city, index) => (
          <CityPreview key={city.index} city={city} onClick={() => selectCity(city)} />
        ))}
      </div>
    </>
  );
};

export default CityBuilderCitySelector;
